/**
 * Functions の画面の「ほかのサービスのキーやパスワード」の欄の日本語（en.fnSecrets.ts と同じキーを全部持つ。漏れは typecheck で落ちる）。
 * 2026-10-04 console/secret-input。言葉の決め事は en.fnSecrets.ts の冒頭と同じ:
 *   「秘密の値」「本番」「環境」「デプロイ」と書かない（console/plain-confirm-2 の決まり）。「パスワード」はふつうに使う。「API キー」は 2026-10-04 console/plain-words-3 でやめた（founder「API という言葉を知らない前提」）=「ほかのサービスのキー」「OpenAI のサイトでもらった長い文字列（キー）」と言う（plainWords.test.ts）。
 *   確認の見出し・結果は確認の画面（ja.confirmPlain.ts の secretPut / secretDelete）と同じ言い方にそろえる。
 */
import type { enFnSecrets } from './en.fnSecrets';

type FnSecretsMessages = { [K in keyof typeof enFnSecrets]: string };

export const jaFnSecrets: FnSecretsMessages = {
  'fnSecret.title': 'OpenAI・Stripeなどのキーやパスワード',
  'fnSecret.lead': 'OpenAIやStripeのサイトでもらった長い文字列（キー。sk-などで始まる）やパスワードを、ここに貼ります。サーバーがそれを使います。保存した値は、この画面にも{product}のどこにも二度と表示されません。',
  'fnSecret.chatWarning': 'キーをAIとの会話に貼らないでください。会話は記録に残り、漏れると他人に使われて、あなたに請求が来ます。ここで入れれば、AIに伝わるのは名前だけです。AIに「キーを入れたい」と言えば、この欄へのリンクを出します。',
  'fnSecret.envNote.production': 'ここで入れた値は、公開中のアプリ（{url}）のサーバーだけが使います。テスト用のアプリでも使うときは、上で「テスト用」に切り替えて、そちらでも入れてください。',
  'fnSecret.envNote.production_noUrl': 'ここで入れた値は、公開中のアプリのサーバーだけが使います。テスト用のアプリでも使うときは、上で「テスト用」に切り替えて、そちらでも入れてください。',
  'fnSecret.envNote.development': 'ここで入れた値は、テスト用のアプリ（{url}）のサーバーだけが使います。公開中のアプリでも使うときは、上で「公開中」に切り替えて、そちらでも入れてください。',
  'fnSecret.envNote.development_noUrl': 'ここで入れた値は、テスト用のアプリのサーバーだけが使います。公開中のアプリでも使うときは、上で「公開中」に切り替えて、そちらでも入れてください。',
  'fnSecret.empty': 'まだありません。',
  'fnSecret.updated': '{ago}に更新',
  'fnSecret.name': '名前',
  'fnSecret.nameHint': '英大文字・数字・_（例: STRIPE_SECRET_KEY）。AI に言われた名前と同じにします。',
  'fnSecret.value': '値',
  'fnSecret.valuePlaceholder': 'ここにキーを貼り付け',
  'fnSecret.save': '保存する',
  'fnSecret.replace': '上書き',
  'fnSecret.replacing': '{name} の新しい値を入れてください。前の値と入れ替わります。',
  'fnSecret.cancelReplace': '別のものを追加する',
  'fnSecret.delete': '削除',
  'fnSecret.saved': '{name} を保存しました。値はこの画面にはもう残っていません。',
  'fnSecret.deleted': '{name} を削除しました。',
  'fnSecret.confirmPutTitle': '{name} を保存しますか？',
  'fnSecret.confirmPutBody': 'パスワードやキーなどの大事な値です。今使っている人にも、すぐに反映されます。この画面には表示しません。',
  'fnSecret.confirmPutButton': '保存する',
  'fnSecret.confirmDeleteTitle': '{name} を削除しますか？',
  'fnSecret.confirmDeleteBody': 'この値を使っている機能は動かなくなります。{product} は値を持っていないので、また使うときは入れ直してください。',
  'fnSecret.confirmDeleteButton': '削除する',
  'fnSecret.nameIssue.empty': '名前を入れてください。',
  'fnSecret.nameIssue.format': '英大文字・数字・_ だけで、英字で始めてください（63 文字まで）。',
  'fnSecret.nameIssue.reserved': 'KUMO_ で始まる名前は {product} が使います。別の名前にしてください。',
  'fnSecret.valueIssue.empty': '値を貼り付けてください。',
  'fnSecret.valueIssue.tooLong': '値が長すぎます（5 KB まで）。',
  'fnSecret.error.notDeployed': 'サーバーを一度公開すると、入れられるようになります。AI に「サーバーを公開して」と頼んでください。',
  'fnSecret.error.disabled': 'サーバーがオフになっています。上の「オンにする」を押してから入れてください。',
  'fnSecret.error.rateLimited': '短い間に何度も保存しています。{seconds} 秒ほど待ってから、もう一度お試しください。',
  'fnSecret.error.notFound': 'もう削除されていました。一覧を読み直しました。'
};
